/* tslint:disable */
/* eslint-disable */
/**
 * Cerebral Machines API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AssetCreate } from '../models';
// @ts-ignore
import type { AssetUpdate } from '../models';
// @ts-ignore
import type { ValidationErrorModel } from '../models';
/**
 * AssetApi - axios parameter creator
 */
export const AssetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new asset
         * @param {AssetCreate} assetCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetCreatePost: async (assetCreate: AssetCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetCreate' is not null or undefined
            assertParamExists('assetCreatePost', 'assetCreate', assetCreate)
            const localVarPath = `/api/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an asset by ID
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetDeleteAssetIdDelete: async (assetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('assetDeleteAssetIdDelete', 'assetId', assetId)
            const localVarPath = `/api/assets/{asset_id}`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download an asset file
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetDownloadAssetIdDownloadGet: async (assetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('assetDownloadAssetIdDownloadGet', 'assetId', assetId)
            const localVarPath = `/api/assets/{asset_id}/download`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an asset by ID
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetGetAssetIdGet: async (assetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('assetGetAssetIdGet', 'assetId', assetId)
            const localVarPath = `/api/assets/{asset_id}`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all assets
         * @param {string | null} [search] 
         * @param {string | null} [mimeType] 
         * @param {string | null} [uploadedBy] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [assetType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetListGet: async (search?: string | null, mimeType?: string | null, uploadedBy?: string | null, limit?: number | null, offset?: number | null, assetType?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (mimeType !== undefined) {
                localVarQueryParameter['mime_type'] = mimeType;
            }

            if (uploadedBy !== undefined) {
                localVarQueryParameter['uploaded_by'] = uploadedBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (assetType !== undefined) {
                localVarQueryParameter['asset_type'] = assetType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an asset by ID
         * @param {string} assetId 
         * @param {AssetUpdate} assetUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetUpdateAssetIdPut: async (assetId: string, assetUpdate: AssetUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('assetUpdateAssetIdPut', 'assetId', assetId)
            // verify required parameter 'assetUpdate' is not null or undefined
            assertParamExists('assetUpdateAssetIdPut', 'assetUpdate', assetUpdate)
            const localVarPath = `/api/assets/{asset_id}`
                .replace(`{${"asset_id"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetApi - functional programming interface
 */
export const AssetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new asset
         * @param {AssetCreate} assetCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetCreatePost(assetCreate: AssetCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetCreatePost(assetCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an asset by ID
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetDeleteAssetIdDelete(assetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetDeleteAssetIdDelete(assetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetDeleteAssetIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download an asset file
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetDownloadAssetIdDownloadGet(assetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetDownloadAssetIdDownloadGet(assetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetDownloadAssetIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get an asset by ID
         * @param {string} assetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetGetAssetIdGet(assetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetGetAssetIdGet(assetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetGetAssetIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all assets
         * @param {string | null} [search] 
         * @param {string | null} [mimeType] 
         * @param {string | null} [uploadedBy] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [assetType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetListGet(search?: string | null, mimeType?: string | null, uploadedBy?: string | null, limit?: number | null, offset?: number | null, assetType?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetListGet(search, mimeType, uploadedBy, limit, offset, assetType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an asset by ID
         * @param {string} assetId 
         * @param {AssetUpdate} assetUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetUpdateAssetIdPut(assetId: string, assetUpdate: AssetUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetUpdateAssetIdPut(assetId, assetUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetApi.assetUpdateAssetIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssetApi - factory interface
 */
export const AssetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new asset
         * @param {AssetApiAssetCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetCreatePost(requestParameters: AssetApiAssetCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssetCreate> {
            return localVarFp.assetCreatePost(requestParameters.assetCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an asset by ID
         * @param {AssetApiAssetDeleteAssetIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetDeleteAssetIdDelete(requestParameters: AssetApiAssetDeleteAssetIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assetDeleteAssetIdDelete(requestParameters.assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download an asset file
         * @param {AssetApiAssetDownloadAssetIdDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetDownloadAssetIdDownloadGet(requestParameters: AssetApiAssetDownloadAssetIdDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assetDownloadAssetIdDownloadGet(requestParameters.assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an asset by ID
         * @param {AssetApiAssetGetAssetIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetGetAssetIdGet(requestParameters: AssetApiAssetGetAssetIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assetGetAssetIdGet(requestParameters.assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all assets
         * @param {AssetApiAssetListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetListGet(requestParameters: AssetApiAssetListGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assetListGet(requestParameters.search, requestParameters.mimeType, requestParameters.uploadedBy, requestParameters.limit, requestParameters.offset, requestParameters.assetType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an asset by ID
         * @param {AssetApiAssetUpdateAssetIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetUpdateAssetIdPut(requestParameters: AssetApiAssetUpdateAssetIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assetUpdateAssetIdPut(requestParameters.assetId, requestParameters.assetUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for assetCreatePost operation in AssetApi.
 */
export interface AssetApiAssetCreatePostRequest {
    readonly assetCreate: AssetCreate
}

/**
 * Request parameters for assetDeleteAssetIdDelete operation in AssetApi.
 */
export interface AssetApiAssetDeleteAssetIdDeleteRequest {
    readonly assetId: string
}

/**
 * Request parameters for assetDownloadAssetIdDownloadGet operation in AssetApi.
 */
export interface AssetApiAssetDownloadAssetIdDownloadGetRequest {
    readonly assetId: string
}

/**
 * Request parameters for assetGetAssetIdGet operation in AssetApi.
 */
export interface AssetApiAssetGetAssetIdGetRequest {
    readonly assetId: string
}

/**
 * Request parameters for assetListGet operation in AssetApi.
 */
export interface AssetApiAssetListGetRequest {
    readonly search?: string | null

    readonly mimeType?: string | null

    readonly uploadedBy?: string | null

    readonly limit?: number | null

    readonly offset?: number | null

    readonly assetType?: string | null
}

/**
 * Request parameters for assetUpdateAssetIdPut operation in AssetApi.
 */
export interface AssetApiAssetUpdateAssetIdPutRequest {
    readonly assetId: string

    readonly assetUpdate: AssetUpdate
}

/**
 * AssetApi - object-oriented interface
 */
export class AssetApi extends BaseAPI {
    /**
     * 
     * @summary Create a new asset
     * @param {AssetApiAssetCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assetCreatePost(requestParameters: AssetApiAssetCreatePostRequest, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetCreatePost(requestParameters.assetCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an asset by ID
     * @param {AssetApiAssetDeleteAssetIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assetDeleteAssetIdDelete(requestParameters: AssetApiAssetDeleteAssetIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetDeleteAssetIdDelete(requestParameters.assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download an asset file
     * @param {AssetApiAssetDownloadAssetIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assetDownloadAssetIdDownloadGet(requestParameters: AssetApiAssetDownloadAssetIdDownloadGetRequest, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetDownloadAssetIdDownloadGet(requestParameters.assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an asset by ID
     * @param {AssetApiAssetGetAssetIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assetGetAssetIdGet(requestParameters: AssetApiAssetGetAssetIdGetRequest, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetGetAssetIdGet(requestParameters.assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all assets
     * @param {AssetApiAssetListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assetListGet(requestParameters: AssetApiAssetListGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetListGet(requestParameters.search, requestParameters.mimeType, requestParameters.uploadedBy, requestParameters.limit, requestParameters.offset, requestParameters.assetType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an asset by ID
     * @param {AssetApiAssetUpdateAssetIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assetUpdateAssetIdPut(requestParameters: AssetApiAssetUpdateAssetIdPutRequest, options?: RawAxiosRequestConfig) {
        return AssetApiFp(this.configuration).assetUpdateAssetIdPut(requestParameters.assetId, requestParameters.assetUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

